<template>
  <div class="chat-layout">
    <div class="hover-btn" @click="showAside=!showAside">
      <vcenter>
        <img :class="{'img-active':!showAside}" :src="`${$cdn}images/chat-btn.png`" alt="">
        <img :class="{'img-active':showAside}" :src="`${$cdn}images/chat-close.png`" alt="">
      </vcenter>
    </div>
    <div class="chat-con" :class="{active:showAside}">
      <div class="c-top">
        <img :src="language === 'en'?`${$cdn}images/chat-logo-en.png`:`${$cdn}images/chat-logo.png`" alt>
        <p :style="{'font-size':language === 'en'?'14px':'16px'}" v-html="langChat.title"></p>
        <img v-if="language !== 'en'" class="wechat-qr" :src="`${$cdn}images/chat-ecode.jpg`" alt>
        <!-- <div class="avatar">
          <div v-for="(item,i) in kefu" :key="i">
            <img :src="item.avatar" alt="">
            <p>{{item.name}}</p>
          </div>
        </div> -->
      </div>
      <div :class="{'c-bottom':true,'c-b-en':language === 'en'}" >
        <div class="cb-input">
          <div class="cb-title" v-if="language !== 'en'">请留言</div>
          <div class="input"><input autocomplete="off" ref="sInput" v-model="email" :placeholder="langChat.p1" type="text"></div>
          <!-- <div class="input"><input autocomplete="off" v-model="phone" :placeholder="langChat.p2" type="text"></div> -->
          <div class="input"><textarea v-model="content" :placeholder="langChat.p3" type="text" /></div>
        </div>
        <div class="btn" @click="send">{{langChat.send}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import vcenter from '@/components/vcenter'
import { mapState } from 'vuex'
import {reg} from '@/util'

export default {
  components: {vcenter},
  computed: {
    ...mapState({
      language: state => state.language.current,
      langToast: state => state.language.home.toast,
      langChat: state => state.language.home.chat
    })
  },
  watch: {
    showAside () {
      this.$nextTick(() => {
        this.$refs.sInput.focus()
      })
      this.email = ''
      this.content = ''
    }
  },
  methods: {
    async send () {
      let {content, email} = this
      if (!content || !email) {
        return
      }
      if (!reg.email.test(email) && !reg.guhua.test(email)) {
        return this.$toast.show('warn', this.langToast['10'])
      }
      let params = {
        content,
        contact: email
      }
      let result = await this.$http({
        method: 'post',
        data: params,
        url: '/intercomMessage/leave'
      })
      let data = result.data
      if (data.code !== 0) {
        return this.$toast.show('warn', this.langToast['11'])
      } else {
        this.$toast.show('warn', this.langToast['12'], () => {
          this.showAside = false
        })
      }
    }

  },
  data () {
    let kefu = [
      {
        name: 'apple',
        avatar: `${this.$cdn}images/avatar-icon1.png`
      },
      {
        name: 'apple',
        avatar: `${this.$cdn}images/avatar-icon2.png`
      },
      {
        name: 'apple',
        avatar: `${this.$cdn}images/avatar-icon3.png`
      }
    ]
    return {
      showAside: false,
      reg,
      kefu,
      email: '',
      content: ''
    }
  }
}
</script>

<style lang="scss" scoped>
$lincolor:#d0d0d1;

.input-con{
    width: 330px;
    padding: 32px 0 0 45px;
    height: 365px;
}

.input{
  height: 40px;
  input,textarea{
    appearance: none;
    border: none;
    border-bottom: 1px $lincolor solid;
    display: block;
    background: none;
    font-size: 14px;
    color: #777;
    width: 100%;
    height:35px;
    margin-top: 14px;
    font-family: Arial;
    &::placeholder {
        color: rgb(165, 165, 165);
    }
  }

  textarea{
    height: 90px;
    border-bottom: none;
    margin-top: 14px;
    color: #777;
  }
}

.chat-layout {
  $wh: 60px;
  position: fixed;
  bottom: 0;
  right: 0;
  transform: translate(-50%,-50%);
  background-color: #1fe4dc;
  text-align: center;
  z-index: 999;
  border-radius: 50%;
  box-shadow: 0 0 20px rgba($color: #000000, $alpha: 0.4);
  // display: none;
  .hover-btn{
    cursor: pointer;
    width: $wh;
    height: $wh;
    img{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%) scale(0);
      transition: 0.3s ease all;
      opacity: 0;
    }
    .img-active{
      opacity: 1;
      transform: translate(-50%,-50%) scale(1);
    }
  }
  .chat-con{
    position: absolute;
    text-align: left;
    bottom:  $wh + 20px;
    right: 0;
    width: 395px;
    height: 503px;
    max-height: 0;
    transition: 0.3s ease all;
    opacity: 0;
    font-size: 14px;
    border-radius: 10px;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.4);
    .c-top{
      background-color: #2ae1d7;
      color: #2d2d2d;
      padding: 23px 7% 26px;
      position: relative;
      justify-content: space-between;
      &>img:first-of-type{
        margin-bottom: 6px;
      }
      .wechat-qr{
        max-width: 120px;
        max-height: 120px;
        margin-top: 20px;
      }

      .avatar{
        display: flex;
        text-align: center;
        position: absolute;
        bottom: 20px;
        div{
          margin-right: 26px;
          img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            overflow: hidden;
          }
        }
      }
    }

    .c-bottom{
      height: calc(503px - 261px - 20px);
      padding:10px 0 0 7%;
      position: relative;
      .cb-title{
        color: #a5a5a5;
        font-size: 16px;
      }
      .cb-input{
        width: 252px;
      }
      .btn{
        bottom: 20px;
        right: 20px;
        position: absolute;
        background-color: #2ae1d7;
        width: 72px;
        text-align: center;
        line-height: 30px;
        height: 30px;
        border-radius: 4px;
        cursor: pointer;
      }
    }
     .c-b-en{
      height: calc(503px - 131px - 20px);
      padding:0 7%;
      .cb-input{
        width: 100%;
      }
    }
  }
  .active{
    max-height: 503px;
    opacity: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/page/chat/index.vue